var React = require('react');

function Stroke2Green (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#7DB343","strokeWidth":"13","d":"M-36 174C68 63 180 7 301 7c182 0 476 107 672 118s470-52 539-85"}));
}

Stroke2Green.defaultProps = {"viewBox":"0 0 1440 147"};

module.exports = Stroke2Green;

Stroke2Green.default = Stroke2Green;
